import React from 'react';

import clsx from 'clsx';

import * as classes from './NoSelectedSensorsScreen.module.css';

const NoSelectedSensorsScreen = ({
    height,
    message,
    style,
    ...props
}) => {

    return (
        <div style={{ height: height, ...style }} className={classes.Body}>
            <div>
                <p className={classes.IconContainer}>
                    <span className={clsx('material-icons md-18', classes.Icon)}>
                        error
                    </span>
                    Attention:
                </p>
                <p>{message}</p>
            </div>
        </div>
    );
};

export default NoSelectedSensorsScreen;
